import type { BlokProps } from "@trydig/storyblok";
import BlokWrap from "@/components/bloks/BlokWrap";
import type { BlokCarouselEndContent } from "@/storyblok";
import styles from "./CarouselEndContent.module.css";

export const CarouselEndContentBlok = ({
	blok,
}: BlokProps<BlokCarouselEndContent>) => {
	return (
		<BlokWrap editable={blok} as="article" className={styles.root}>
			<p className={styles.title}>{blok.title}</p>
			{blok.description && (
				<p className={styles.description}>{blok.description}</p>
			)}
		</BlokWrap>
	);
};
